unit xweb.xdata;

interface

uses classes, sysutils, xdata.Web.Connection, xdata.Web.Client, Web, system.Generics.Collections, rtti,
  vcl.TMSFNCTypes, js, vcl.TMSFNCPersistence;

type
  twxResultEvent = procedure(R: tXDataClientResponse) of Object;

type
  twxErrorEvent = procedure(Error: TXDataWebConnectionError) of object;

  tWXDataBase = class
  private
    FonResult: twxResultEvent;
    FonConnected: tNotifyEvent;
    FConnection: txdatawebConnection;
    Fclient: txdataWebClient;
    fOnError: twxErrorEvent;
  public
    procedure xConnected(sender: tobject);
    procedure xError(Error: TXDataWebConnectionError);
    procedure xRequest(Args: TXDataWebConnectionRequest);
    procedure xResponse(Args: TXDataWebConnectionResponse);
    function GetConnected: boolean;
    procedure SetConnected(const Value: boolean);
    constructor create;
  published
    property Connection: txdatawebConnection read FConnection write FConnection;
    property Client: txdataWebClient read Fclient write Fclient;
    property onResult: twxResultEvent read FonResult write FonResult;
    property OnError: twxErrorEvent read fOnError write fOnError;
    property onConnected: tNotifyEvent read FonConnected write FonConnected;
    property connected: boolean read GetConnected write SetConnected;

  end;

implementation

   uses xweb.webman;
{ tWXDataBase }

constructor tWXDataBase.create;
begin
  Connection := txdatawebConnection.create(nil);
  Connection.OnConnect := xConnected;
  Connection.OnError := xError;

  Connection.OnRequest := xRequest;
  Connection.OnResponse := xResponse;
  Connection.URL := webman.site.V('XdAuth');

  Client := txdataWebClient.create(nil);
  Client.Connection := FConnection;
end;

function tWXDataBase.GetConnected: boolean;
begin
     Result := Connection.connected;
end;

procedure tWXDataBase.SetConnected(const Value: boolean);
begin
  Connection.connected:=value;
end;

procedure tWXDataBase.xConnected(sender: tobject);
begin
      CONsole.log('XData Connected', sender);
    if assigned(onConnected) then
      onConnected(sender);
end;

procedure tWXDataBase.xError(Error: TXDataWebConnectionError);
begin
     CONsole.Error('XData Error', Error);
    if assigned(OnError) then
      OnError(Error);
end;

procedure tWXDataBase.xRequest(Args: TXDataWebConnectionRequest);
begin

end;

procedure tWXDataBase.xResponse(Args: TXDataWebConnectionResponse);
begin

end;

end.
